/** askKM 前端 API 共用模組(自 public/js/api.js 移植為型別化 ES 模組)。 */
import type { Me } from './types';

export interface RequestOptions extends Omit<RequestInit, 'body'> {
  /** 帶此欄位時自動轉為 POST + JSON body */
  json?: unknown;
  body?: BodyInit | null;
}

/**
 * 呼叫後端 API。
 * - 401 一律導回登入頁(/api/auth/* 自身除外,否則登入失敗會變成無限跳轉)
 * - 非 2xx 以後端的 { error } 訊息拋出,呼叫端只需 catch 一種形狀
 */
export async function request<T = unknown>(path: string, options: RequestOptions = {}): Promise<T> {
  const { json, ...rest } = options;
  const opts: RequestInit = { credentials: 'same-origin', ...rest };

  if (json !== undefined) {
    opts.method = opts.method ?? 'POST';
    opts.headers = { 'Content-Type': 'application/json', ...(opts.headers ?? {}) };
    opts.body = JSON.stringify(json);
  }

  const res = await fetch(path, opts);
  if (res.status === 401 && !path.startsWith('/api/auth')) {
    window.location.href = '/login.html';
    throw new Error('未登入');
  }

  const data = (await res.json().catch(() => ({}))) as { error?: string };
  if (!res.ok) throw new Error(data.error || `HTTP ${res.status}`);
  return data as T;
}

/** 取得目前登入者;未登入導回登入頁 */
export async function requireAuth(): Promise<Me> {
  try {
    return await request<Me>('/api/auth/me');
  } catch (e) {
    window.location.href = '/login.html';
    throw e;
  }
}
